<template>
  <div class="large-options width-expand">
    <component
      :is="optionComponent"
      class="width-expand"
      v-for="option in list"
      :selected="value === option.value"
      v-bind="{ ...option,...optionComponentProps,}"
      @large-option:selected="value = option.value">
    </component>
  </div>
</template>

<script>
import SimpleInputMixin from "@/client/extensions/mixins/baseComponents/form/controls/input/simpleInput.js";

export default {
  mixins: [SimpleInputMixin],
  props: {
    title: {
      type: [Boolean, String],
      default: false,
    },
    description: {
      type: [Boolean, String],
      default: false,
    },
    endText: {
      type: [Boolean, String],
      default: false,
    },
    list: {
      type: Array,
      default: [],
    },
    optionComponent: {
      type: String,
      default: "LargeOption",
    },
    optionComponentProps: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
